import { buildRevisionCompletionScopeKey } from '../listing-draft-payload.js';

export function createRevisionWritebackController({
  getState,
  setStateBulk,
  ensureKeywordsWithVolume,
  buildDiffItems,
  buildWritebackMeta,
  navigateToStep,
  getElementById,
  clearOptimizationPanels,
  applyGenerationResult,
  syncNavigationBounds,
  renderDiffNotice,
  windowRef = globalThis.window,
}) {
  function writeToStep03(normalized, stepReady, execution = {}) {
    const nextTitle = normalized.title || getState('listingDraftTitle');
    const nextBullets = normalized.bullets || getState('listingDraftBullets');
    const nextDesc = normalized.description || getState('listingDraftDescription');
    const nextSt = normalized.searchTerms
      ? ensureKeywordsWithVolume(normalized.searchTerms)
      : getState('listingDraftSearchTerms');
    const nextQa = normalized.qa || getState('listingDraftQa');
    const nextDraft = {
      title: nextTitle,
      bullets: nextBullets,
      description: nextDesc,
      searchTerms: nextSt,
      qa: nextQa,
    };
    const diffItems = buildDiffItems({
      ...nextDraft,
    });
    const productInfo = getState('productInfo') || null;
    const businessContext = getState('businessContext') || null;
    const keywordUsePolicies = getState('keywordUsePolicies') || businessContext?.keywordUsePolicies || [];
    const competitorRoles = getState('competitorRoles') || businessContext?.competitorRoles || [];
    const revisionCompletion = execution?.revisionCompletion?.approved === true
      ? {
          ...execution.revisionCompletion,
          scopeKey: buildRevisionCompletionScopeKey({
            listing: nextDraft,
            marketplace: getState('marketplace') || productInfo?.marketplace || productInfo?.targetMarket || '',
            productInfo,
            keywordUsePolicies,
            competitorRoles,
          }),
        }
      : null;
    const nextMeta = buildWritebackMeta(
      normalized.meta || {},
      normalized.task || {},
      revisionCompletion ? { ...execution, revisionCompletion } : execution
    );

    navigateToStep(3);
    getElementById('step-generation')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    clearOptimizationPanels();

    applyGenerationResult({
      title: nextTitle,
      bullets: nextBullets,
      description: nextDesc,
      searchTerms: nextSt,
      qa: nextQa,
      meta: nextMeta,
      v1: normalized.v1,
      optimizerResult: normalized.optimizerResult,
    });

    setStateBulk({
      listingDraftTitle: nextTitle,
      listingDraftBullets: nextBullets,
      listingDraftDescription: nextDesc,
      listingDraftSearchTerms: nextSt,
      listingDraftQa: nextQa,
      listingGenerationMeta: nextMeta,
      selectedTitleVersion: 0,
      complianceResult: null,
      scoringReport: null,
      revisionSuggestions: [],
      revisionAdviceText: '',
      revisionOverview: null,
      revisionSuggestionsMeta: null,
      revisionSuggestionsError: '',
      revisionCandidateDraft: null,
      revisionSearchTermsDraft: null,
      algorithmTips: null,
      stepReady: { ...stepReady, 4: false },
    });
    syncNavigationBounds();
    const functionTrace = nextMeta?.mergeMeta?.functionTrace || null;
    renderDiffNotice(diffItems, {
      taskId: normalized.task?.taskId || '',
      traceId: normalized.task?.traceId || functionTrace?.traceId || '',
      functionTrace,
    });

    windowRef?.__refreshStep3ListingView?.();
    return diffItems;
  }

  return { writeToStep03 };
}
